module.exports = __webpack_public_path__ + "img/bulb.db299f67.svg";